// The consent sentence under a button that creates an After account or
// texts a visitor. One builder for every screen that carries it, so the
// wording a visitor agrees to cannot drift between them. Terms and Privacy
// Policy are linked between `lead` and `tail` by the component.

export interface ConsentDisclosure {
  /** The text before the Terms link. */
  lead: string;
  /** The text after the Privacy Policy link. */
  tail: string;
}

/** Which number the marketing-text consent names. */
type TextConsentNumber =
  | { kind: "provided" }
  | { kind: "entered" }
  | { kind: "on_file"; lastFour: string };

interface ConsentDisclosureInput {
  /** The label on the button the disclosure sits under. */
  action: string;
  /** The visitor already has an After account, so nothing is created. */
  hasAccount: boolean;
  /** The number texts go to; null when the button sends no text. */
  texting: TextConsentNumber | null;
}

function numberPhrase(number: TextConsentNumber): string {
  switch (number.kind) {
    case "provided":
      return "the number provided";
    case "entered":
      return "the number you entered";
    case "on_file":
      return `the number ending in ${number.lastFour}`;
  }
}

export function consentDisclosure(
  input: ConsentDisclosureInput,
): ConsentDisclosure {
  const lead = input.hasAccount
    ? `By pressing “${input.action}” you agree to the `
    : `By pressing “${input.action}” you are creating an After account and agree to the `;
  if (input.texting === null) return { lead, tail: "." };
  return {
    lead,
    tail: `, and consent to receive recurring automated marketing texts from After.com at ${numberPhrase(input.texting)}, even if it’s on a Do-Not-Call list. Msg & data rates may apply. Msg frequency varies. Reply HELP for help, STOP to cancel. Consent is not a condition of purchase.`,
  };
}
